import React from "react";
import { formatDate, getAssessmentBadgeClass } from "../../../utils/dateFormatting";

const formatDateForModal = (dateStr) => formatDate(dateStr) || 'N/A';

export default function SessionHistoryModal({ show, onClose, selectedPatientForHistory, sessionHistory, loadSessionNotes, setSelectedSessionDetails }) {
  if (!show || !selectedPatientForHistory) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px', maxHeight: '80vh', overflowY: 'auto' }}>
        <h2>Session History - {selectedPatientForHistory.name}</h2>
        {sessionHistory.length === 0 ? (
          <p style={{ color: '#000000' }}>No session history available.</p>
        ) : (
          <div>
            <table className="session-history-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Duration</th>
                  <th>Emotions</th>
                  <th>Assessment</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sessionHistory.map((session) => (
                  <tr key={session.session_id}>
                    <td>{formatDateForModal(session.session_date)}</td>
                    <td>{session.duration_seconds ? `${session.duration_seconds}s` : 'N/A'}</td>
                    <td>
                      {session.emotion ? (
                        <div style={{ fontSize: '12px' }}>
                          Joy: {session.emotion.joy?.toFixed(1)}%,
                          Stress: {session.emotion.stress?.toFixed(1)}%,
                          Sadness: {session.emotion.sadness?.toFixed(1)}%,
                          Anger: {session.emotion.anger?.toFixed(1)}%
                        </div>
                      ) : 'No data'}
                    </td>
                    <td>
                      <span className={`badge ${getAssessmentBadgeClass(session.emotion?.doctor_assessment)}`}>
                        {session.emotion?.doctor_assessment || 'N/A'}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn-secondary"
                        onClick={async () => {
                          setSelectedSessionDetails(session);
                          await loadSessionNotes(session.session_id);
                        }}
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div style={{ marginTop: '16px' }}>
          <button className="btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
